import EmbedTopBar from './container';

export default EmbedTopBar;
